export const lang = {
  editInfo: {
    name: 'नाम',
    uid: 'यूआईडी',
    permanentIdentifier: 'स्थायी पहचानकर्ता',
    copy: 'कॉपी',
    phoneNumber: 'फ़ोन नंबर',
    saveChanges: 'परिवर्तन सहेजें',
    nameError: 'कृपया 4-20 अक्षरों का नाम दर्ज करें'
  }
}



// WEBPACK FOOTER //
// ./src/assets/locale/hi-IN.js